
import { func } from '../../main';
import axios from '../../api'
import router from '../../router';


const state = {
    ReminderList: [],
    ReminderCalendarList: [],
    ReminderTypeList: [],
    ReminderNo: "",
    ReminderNoMoreData: false,
    Loading:false,
    UpdateReminderList:true,

};


const getters = {
    GetReminderList(state:any) {
        return state.ReminderList;
    },
    GetReminderCalendarList(state:any) {
        return state.ReminderCalendarList;
    },
    GetReminderTypeList(state:any) {
        return state.ReminderTypeList;
    },
    GetReminderNo(state:any) {
        return state.ReminderNo;
    },
    GetReminderNoMoreData(state:any) {
        return state.ReminderNoMoreData;
    },
    GetUpdateReminderList(state:any){
        return state.UpdateReminderList;
    }
};

const mutations = {

    SetReminderList(state:any, list:any) {
        state.ReminderList = list;
    },
    SetReminderCalendarList(state:any, list:any) {
        state.ReminderCalendarList = list;
    },
    AddReminderList(state:any, list:any) {
       
        state.ReminderList=state.ReminderList.concat(list);
    },
    SetReminderTypeList(state:any, list:any) {
        state.ReminderTypeList = list;
    },
    SetReminderNo(state:any, no:any) {
        state.ReminderNo = no;
    },
    SetReminderNoMoreData(state:any, val:any) {
        state.ReminderNoMoreData = val;
    },
    SetUpdateReminderList(state:any,val:any){
        state.UpdateReminderList =val;
    }
};

const actions = {
    GetReminderListFromServer(context:any, Filter:any) {
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("Reminder/GetReminderList", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                userId: Filter.userId,
                projectId: Filter.projectId,
                status: Filter.status,
                date: Filter.date,
                searchKey:Filter.searchKey
            }
        })
           .then(data => {
                context.commit("SetLoading", false);
                context.commit('SetUpdateReminderList', false);

                if (data.data.length < 1) {
                    context.commit("SetReminderNoMoreData", true);
                }
                if (Filter.pageId == 1) {
                    context.commit("SetReminderNoMoreData", false);
                    context.commit("SetReminderList", data.data);
                }
                else {
                    context.commit("AddReminderList", data.data);
                }
            });
    },
    ClearReminderList(context:any) {
        context.commit("SetReminderList", []);
    },
    GetReminderTypeListFromServer(context:any) {
        axios.get("Reminder/GetReminderRepeatTypeList")
           .then(data => {
                context.commit("SetReminderTypeList", data.data);
            });
    },
    GetReminderCalendarListFromServer(context:any,Filter:any) {
        axios.get("Reminder/CalcCalendar", {
            params: {
                id: Filter.reminderId,
                startDate: Filter.startDate,
                endDate: Filter.endDate,
                interval: Filter.interval,
                typeId: Filter.typeId,
                changed: Filter.isChanged
            }
        })
           .then(data => {
                context.commit("SetReminderCalendarList", data.data);
            });
    },
   
    CreateReminder(context:any, item:any) {
        context.commit("SetLoading", true);

        axios.post('Reminder/CreateReminderSend', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a:any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.")
                context.commit('SetUpdateReminderList', true);
                setTimeout(function () { router.push('/ReminderList'); }, 1500);
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditReminder(context:any, item:any) {
        context.commit("SetLoading", true);

        axios.post('Reminder/EditReminderSend', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a:any) => a.errorMessage);
                alert(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.")
                context.commit('SetUpdateReminderList', true);
                setTimeout(function () { router.push('/ReminderList'); }, 1500);
            }
            context.commit("SetLoading", false);
        }, error => {
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
